import { Component, OnInit, Input, OnDestroy,ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

import { ContractService } from './../../../../services/contract.service';
import { AdminService } from '../../../../services/Admin.service';
import { takeWhile } from 'rxjs/operator/takeWhile';
import { DataService } from '../../../../services/data.service';
import { ModalComponent } from '../../../../shared-components/modal/modal.component';

declare var $: any;

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent implements OnInit, OnDestroy {
  public crasmmView: boolean;
  public cscView: boolean;
  public aircraftsale:boolean;
  public contractheaderInfo: any = {};
  @ViewChild('templateAFForm') templateAFForm: ModalComponent;
  public contractNumber: string;
  public isreadyforSale: boolean;
  alive = true;

  // tslint:disable-next-line:max-line-length
  constructor(location: Location, private route: ActivatedRoute, private router: Router, public contractService: ContractService, private dataService: DataService) {

  }
  
  onsubmitAFSale(){
    //update flag on credithold & send email notification
    console.log('onsubmitAFSale: '+this.contractNumber);
    if(!this.isreadyforSale)
    {
      alert("please confirm the release information");
       return;
    }
    this.contractService.sendAFSale(this.contractNumber)
    .takeWhile(() => this.alive)
          .subscribe(
            data => {
             
              console.log(data);
             
            },
            err => {
             
              console.log(err._body);
            }
    
          );
   this.templateAFForm.hide();
  }

  onOpenMTSFormModal() {
    console.log('onOpenMTSFormModal: ');
     this.templateAFForm.show();
   }
   onCloseMTSFormModal() {
     this.templateAFForm.hide();
   }

   downloadWord(doctype: string ) {
    this.contractService.DownLoadDocInfo(this.contractNumber,doctype)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        console.log('report'+data);
        const byteCharacters = atob(data);
        const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        if(doctype.indexOf('InfoReleaseDocument')>=0){

        link.download = 'Information Release '+this.contractNumber+'.docx'; // File name for download
        }
        else 
        {
          link.download = 'Notice of Aircraft Sale '+this.contractNumber+'.docx'; // File name for download
        }
        link.target='_blank';
        link.click();
       
        
      },
      err => {
       
        console.log(err);
      }
    );
     
  }
  openPdf(event: Event) {
    event.preventDefault(); // stop Angular routing
    window.open('assets/files/JSSI Aircraft Sale Reference Guide.pdf', '_blank');
  }

  ngOnInit() {

      this.route.params
      .subscribe(params => {
        this.contractNumber = params['id'];

        this.contractService.setSelectedContract(this.contractNumber)
          .takeWhile(() => this.alive)
          .subscribe(data => {
            console.log('SelectedContract got set on Contract service.',data);
            this.dataService.userDisplayInfo.id = data.AdminGuid;
            if (data.bearerToken) {
            this.dataService.userDisplayInfo.adminbearerToken = data.bearerToken;
            }
          },
            err => {
              // User might now try to browse a contract doesn't belong to him/her
              this.router.navigate(['/pages/client/my-contracts/']);
            }
          );

        console.log('New contract info pre-loaded. Contract Number: ' + this.contractNumber);

      });
  }


  getFittedMakeModel(makeModel: string) {

    if (makeModel) {

      if (makeModel.length > 25) {
        console.log(makeModel + 'makemodel');
        return makeModel.slice(0, 25);
      } else {
        return makeModel;
      }
    } else {
      return '';
    }

    // tslint:disable-next-line:max-line-length
    // { { (contractheaderInfo ?.MakeModel ?.length > 21) ? (contractheaderInfo ?.MakeModel | slice : 0: 21) +'...': (contractheaderInfo ?.MakeModel) } }
  }

  updateRegister() {
    // tslint:disable-next-line:max-line-length
    this.router.navigate(['/pages/client/my-contracts/contract/' + this.contractService.selectedContract.ContractNumber + '/update-registration']);
    console.log('inside registration click', this.contractService.selectedContract.ContractNumber);
  }

  IsADUser() {
    return this.dataService.userDisplayInfo.UserTypeID === 5;
  }

  ngOnDestroy() {
    this.alive = false;
  }

  shouldShowItem(): boolean {
    if (this.IsADUser()) {
      return false;
    }
  
    var codes: string[] = [];
  
    if (this.contractService.selectedContract &&
        this.contractService.selectedContract.HoldReasonCode) {
  
      codes = this.contractService.selectedContract.HoldReasonCode
        .split(',')
        .map(function (c) {
          return c.trim();
        });
    }
  
    return codes.indexOf('9') === -1 && codes.indexOf('19') === -1;
  }
  

}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-contracts/contract/contract.component.ts